/**
 * Wischen soll nur wischen, wenn wirklich gewischt wird.
 *
 * Flickity startet das Ziehen, sobald die Fingerbewegung waagerecht die
 * Schwelle ueberschreitet — die senkrechte Bewegung wird dabei gar nicht
 * angeschaut (vendor.min.js: hasDragStarted prueft nur moveVector.x). Beim
 * Scrollen auf dem Telefon laeuft der Daumen aber fast nie exakt senkrecht.
 * Ein langer Scrollzug mit ein paar Pixeln seitlichem Versatz reichte
 * deshalb aus, um die Bildergalerie auf der Produktseite weiterzublaettern.
 *
 * Die Ergaenzung verlangt zusaetzlich, dass die Geste deutlich waagerechter
 * als senkrecht ist. Ein bewusstes Wischen erfuellt das muehelos, ein
 * Scrollzug nicht. Gilt fuer alle Karussells im Theme.
 */
(function () {
	var verhaeltnis = 1.4;
	// Die Bildergalerie der Produktseite zieht erst ab 18 Pixeln. Alle anderen
	// Karussells standen auf Flickitys Vorgabe von 3 Pixeln; sie bekommen
	// dieselbe Schwelle, damit sich das Wischen ueberall gleich anfuehlt.
	var mindestWeg = 18;

	function ergaenzen() {
		if (!window.Flickity || Flickity.prototype.wischSchwelleGesetzt) return false;

		Flickity.prototype.hasDragStarted = function (moveVector) {
			var waagerecht = Math.abs(moveVector.x);
			var senkrecht = Math.abs(moveVector.y);
			var schwelle = Math.max(this.options.dragThreshold, mindestWeg);
			return waagerecht > schwelle && waagerecht > senkrecht * verhaeltnis;
		};
		Flickity.prototype.wischSchwelleGesetzt = true;
		return true;
	}

	if (!ergaenzen()) {
		// vendor.min.js koennte noch nicht da sein. Kurz nachfassen, dann
		// aufgeben; laenger als vier Sekunden dauert das Laden nicht.
		var versuche = 0;
		var takt = window.setInterval(function () {
			if (ergaenzen() || ++versuche > 40) window.clearInterval(takt);
		}, 100);
	}
})();
